import { render, staticRenderFns } from "./CreatePDPObjectiveModal.vue?vue&type=template&id=07784e68&scoped=true&"
import script from "./CreatePDPObjectiveModal.vue?vue&type=script&lang=js&"
export * from "./CreatePDPObjectiveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07784e68",
  null
  
)

export default component.exports